// Pure helper for the Table Management "Edit Table" modal.
//
// Kept in its own module (no React/UI imports) so the update-table contract
// can be unit-tested in isolation. See GitHub issue #279: handleSave built the
// update body from only { table_number, seating_capacity, floor, shape }, so
// the modal's Active toggle and Section field changed local form state but were
// silently dropped on save — the user got a success toast while nothing changed.

import type { TableShape, UpdateTablePayload } from '@/services/table.service';

export interface BuildUpdateTableInput {
  tableNumber: string;
  seatingCapacity: number;
  floor: string;
  section: string;
  shape: TableShape;
  isActive: boolean;
}

// Build the update-table request body. `section` and `is_active` MUST be
// included so the Section field and Active toggle actually persist. A blank
// section is sent as `null` (not '') so the list keeps rendering the floor via
// `section ?? floor` instead of showing an empty cell.
export function buildUpdateTablePayload(input: BuildUpdateTableInput): UpdateTablePayload {
  const section = input.section.trim();
  return {
    table_number: input.tableNumber,
    seating_capacity: input.seatingCapacity,
    floor: input.floor,
    shape: input.shape,
    section: section ? section : null,
    is_active: input.isActive,
  };
}
